// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"88b28624","91":"0c437b18","93":"9e9d171e","192":"27338ce4","206":"d81c60af","249":"65c3ebd2","338":"f6de2b76","402":"94e2ccc6","452":"26d6e9d8","617":"2df79251","671":"ef8517b3","677":"48018f9c","763":"2a847e79"}[chunkId] + ".chunk.js";
};